// extracted by mini-css-extract-plugin
module.exports = {"container":"VerticalServiceFlowStep_container__gWuYM","image":"VerticalServiceFlowStep_image__JR_6f"};